import useWarehouseColumns from '../../utils/useWarehouseColumns';
import { PRODUCT_WORKSPACE_DETAIL_FIELDS } from '../../views/product/ProductWorkspace';
import React from 'react';
import { InnerQueryWidget, IQueryWidgetProps, useItemQuery } from './Widget';

export const ProductQueryWidget = ({
  item,
  itemSecondary,
  gridMetrics: { rowHeight, cardWidth },
  viewProps,
}: IQueryWidgetProps) => {
  const warehouseColumns = useWarehouseColumns('productWarehouseDetails', PRODUCT_WORKSPACE_DETAIL_FIELDS);

  const { queryProps, results, value } = useItemQuery(item, viewProps, warehouseColumns);
  const { value: value2 } = useItemQuery(itemSecondary, viewProps, warehouseColumns);
  return (
    <InnerQueryWidget
      item={item}
      rowHeight={rowHeight}
      cardWidth={cardWidth}
      queryProps={queryProps}
      results={results}
      value={value}
      value2={value2}
    />
  );
};
